
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-width":"1.1","d":"M10.7 15.1V1.9M3 1.9h11A1.1 1.1 0 0 1 15.1 3v11a1.1 1.1 0 0 1-1.1 1.1H3A1.1 1.1 0 0 1 1.9 14V3A1.1 1.1 0 0 1 3 1.9Z"}})])
          )
        }
      }
    